import React, { useRef } from "react";
import { useOnScreen } from "./useOnScreen";

const PLACEHOLDER_IMAGE_URL = "http://cdn.auroraelec.ru/static/250px.svg";

const createAllFiledsString = (
    productId,
    productPartNumber,
    productManufacturerId,
    productManufacturerName,
    productAttributeValue,
    productAttributeKey,
) => {
    return (
        productId +
        productPartNumber +
        productManufacturerId +
        productManufacturerName +
        productAttributeValue +
        productAttributeKey
    );
};

const makeFilterValue = (productAttributeKey, productAttributeValue) => {
    const result = [{ [productAttributeKey]: productAttributeValue }];
    return JSON.stringify(result);
};

const HintItem = ({
    productId,
    productPartNumber,
    productManufacturerId,
    productManufacturerName,
    productAttributeValue,
    productAttributeKey,
    packageType,
    stockQuantity,
    orderQuantity,
    description,
    categoryName,
    imageSrc,
    CustomRouter,
}) => {
    const ref = useRef(null);
    const isVisible = useOnScreen(ref);
    const imageSource = isVisible && imageSrc ? imageSrc : PLACEHOLDER_IMAGE_URL;
    const primaryTitle = productPartNumber || productAttributeValue;
    const secondaryTitle = productPartNumber ? productManufacturerName : productAttributeKey;
    const categoryText = categoryName || "";
    const packageText = packageType || "";
    const descriptionText = description || "";

    const routeToThePageFunction = () => {
        if (!CustomRouter || typeof CustomRouter.navigate !== "function") return;

        if (productPartNumber) {
            CustomRouter.navigate(`/product/${productId}`);
        } else {
            CustomRouter.navigate(
                `/search/?q=${productAttributeValue}&filter=${makeFilterValue(productAttributeKey, productAttributeValue)}`,
            );
        }
    };

    return (
        <li
            key={createAllFiledsString(
                productId,
                productPartNumber,
                productManufacturerId,
                productManufacturerName,
                productAttributeValue,
                productAttributeKey,
            )}
            className="search-options__item"
            onClick={routeToThePageFunction}
            ref={ref}
            id={productId}
        >
            <div className="search-hint__row">
                <div className="search-hint__col search-hint__col--image">
                    <img
                        className="search-options__image"
                        src={imageSource}
                        alt={primaryTitle}
                        onError={(event) => {
                            event.currentTarget.onerror = null;
                            event.currentTarget.src = PLACEHOLDER_IMAGE_URL;
                        }}
                    />
                </div>
                <div className="search-hint__col search-hint__col--content">
                    <div className="search-options__content">
                        <div className="search-hint__title">
                            <span className="search-options__name">
                                {primaryTitle}
                                {secondaryTitle && <span className="mob-manufacturer"> {secondaryTitle}</span>}
                            </span>
                            {categoryText && <span className="search-options__key">{categoryText}</span>}
                        </div>
                        <div className="search-options__details">
                            <div className="search-options__details-col">
                                <div className="search-options__details-title">Корпус</div>
                                <div className="search-options__package">{packageText}</div>
                            </div>
                            <div className="search-options__details-col">
                                <div className="search-options__details-title">Описание</div>
                                <div className="search-options__description">{descriptionText}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    );
};

export default HintItem;

